export default __webpack_public_path__ + "static/media/no-lunch-for-you.d8e072eb.md";